/*
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights.
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing.
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take
any and all actions deemed appropriate to safeguard its rights in and to the content of this document.
*/
import 'core-js/es6/symbol';
import 'core-js/es6/reflect';
import 'core-js/es6/promise';
import 'core-js/fn/promise/finally';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/includes';
import 'core-js/fn/array/find';
import 'normalize.css';

import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment-timezone';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { translations as componentTranslations, ConnectedIntlProvider } from 'tss-core-lib-components';
import { enMessages as commonENMessages } from 'tss-core-lib-common';

import configureStore from './store';
import App from './App';
import './index.css';

import enMessages from './translations/en.json';

// Force moment to use monday as start of week (sunday is default for "en" locale)
moment.updateLocale( moment.locale(), {
  week: {
    dow: 1,
    doy: 4,
  },
} );

const translations = {
  en: {
    ...commonENMessages,
    ...enMessages,
    ...componentTranslations.en,
  },
};

// If Sentry.io is setup, handle promise rejections
if ( window.Raven ) {
  window.addEventListener( 'unhandledrejection', ( event ) => window.Raven.captureException( event.reason ) );
}

const store = configureStore();

const init = () => {
  ReactDOM.render(
    <Provider store={ store }>
      <ConnectedIntlProvider translations={ translations }>
        <BrowserRouter basename={ window.contextPath || '/' }>
          <App />
        </BrowserRouter>
      </ConnectedIntlProvider>
    </Provider>,
    document.getElementById( 'root' ),
  );
};

if ( !global.Intl ) {
  require.ensure( [ 'intl' ], ( require ) => {
    require( 'intl' );
    init();
  } );
} else {
  init();
}



// WEBPACK FOOTER //
// ./src/setup.js